import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxWidth: 16,
  viewboxHeight: 16,
};

const NewCircleIcon = ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      viewboxHeight={viewboxHeight}
      viewboxWidth={viewboxWidth}
      {...rest}
    >
      <g>
        <path
          d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM5.72 6v4.667a.5.5 0 0 1-.387.486H5.22a.506.506 0 0 1-.447-.273L3.707 8.733a.187.187 0 0 0-.194-.066.173.173 0 0 0-.126.166v1.834a.5.5 0 1 1-1 0V6a.5.5 0 0 1 .946-.227L4.407 7.92a.173.173 0 0 0 .186.087.173.173 0 0 0 .127-.167V6a.5.5 0 1 1 1 0Zm.573.78a1.28 1.28 0 0 1 1.28-1.28h1.554a.5.5 0 1 1 0 1H7.573a.28.28 0 0 0-.28.28v.887a.167.167 0 0 0 .167.166h.887a.5.5 0 1 1 0 1H7.46A.167.167 0 0 0 7.293 9v.887a.28.28 0 0 0 .28.28h1.554a.5.5 0 1 1 0 1H7.573a1.28 1.28 0 0 1-1.28-1.28V6.78Zm6.434 4.067-.347-.907a.174.174 0 0 0-.16-.113.173.173 0 0 0-.153.113l-.354.907a.493.493 0 0 1-.526.313.494.494 0 0 1-.434-.433l-.586-4.667a.5.5 0 1 1 .993-.12l.253 2a.187.187 0 0 0 .147.147.16.16 0 0 0 .173-.087v-.047a.52.52 0 0 1 .934 0V8a.166.166 0 0 0 .32-.04l.253-2a.5.5 0 1 1 .993.12l-.586 4.667a.493.493 0 0 1-.434.433h-.06a.5.5 0 0 1-.426-.333Z"
          fill="currentColor"
        />
      </g>
    </SVGLoader>
  );
};

export default NewCircleIcon;
